<template>
  <v-container class="d-flex justify-center body-1">
    <v-card flat>
      <v-row justify="space-between" align="center">
        <v-col class="mr-8">
          <v-row align="center" justify="space-between">
            <v-col cols="2" class="text-center">
              <a @click="isDark = !isDark">
                <v-icon v-if="isDark">mdi-brightness-4</v-icon>
                <v-icon v-else>mdi-brightness-7</v-icon>
              </a>
            </v-col>
            <v-col cols="10">
              <v-color-picker
                v-if="!isDark"
                v-model="settings.colors.light"
                canvas-height="100px"
                flat
                hide-inputs
              />
              <v-color-picker
                v-else
                v-model="settings.colors.dark"
                canvas-height="100px"
                flat
                hide-inputs
              />
            </v-col>
          </v-row>
          <v-row class="d-flex flex-column">
            <v-file-input
              v-model="banner"
              prepend-icon="mdi-camera"
              name="banner"
              @change="file => previewImage('banner', file)"
              :label="$t('Banner')"
              accept="image/png, image/jpeg, image/gif"
            />

            <v-file-input
              v-model="logo"
              prepend-icon="mdi-camera"
              name="logo"
              @change="file => previewImage('logo', file)"
              :label="$t('Logo')"
              accept="image/png, image/jpeg, image/gif"
            />

            <v-row justify="space-between" align="center" class="ml-0">
              <div>{{ $t("Can call waiter") }}</div>
              <v-switch v-model="settings.waiter" />
            </v-row>
            <v-row justify="space-between" align="center" class="ml-0">
              <v-select :items="langs" v-model="settings.locale" :label="$t('Idioma')"></v-select>
            </v-row>
          </v-row>
        </v-col>
        <v-col class="ml-8">
          <MobileIphone :sizeFactor="0.6">
            <PreviewMenu
              class="content"
              :color="previewColor"
              :isDark="isDark"
              :images="settings"
              :waiter="settings.waiter"
            />
          </MobileIphone>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import PreviewMenu from "@/views/dashboard/components/PreviewMenu";
import MobileIphone from "@/views/dashboard/components/MobileIphone";

export default {
  components: { MobileIphone, PreviewMenu },
  props: ["settings"],

  data() {
    return {
      logo: null,
      banner: null,
      isDark: false,
      langs: [
        { text: this.$t("Español"), value: "es" },
        { text: this.$t("Ingles"), value: "en" },
        { text: this.$t("Gallego"), value: "gl" }
      ]
    };
  },

  methods: {
    previewImage(fileName, file) {
      var reader = new FileReader();
      reader.onload = e => {
        this.settings[fileName] = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  },

  computed: {
    previewColor() {
      return this.settings.colors[this.isDark ? "dark" : "light"];
    }
  },

  created() {
    let restaurant = this.$store.getters.restaurant;
    this.settings.banner = restaurant.banner;
    this.settings.logo = restaurant.logo;
    this.settings.waiter = restaurant.waiter || false;
    this.settings.locale = restaurant.locale || false;
    if (restaurant.colors) {
      this.settings.colors.light = restaurant.colors.light;
      this.settings.colors.dark = restaurant.colors.dark;
    } else {
      this.settings.colors = {
        light: this.$vuetify.theme.themes.light.primary,
        dark: this.$vuetify.theme.themes.dark.primary
      };
    }
  }
};
</script>

<style></style>
